import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useActiveLeague } from '../../App';
import CampaignWizard from './CampaignWizard';

export default function CampaignEditPage() {
    const { campaignId } = useParams();
    const { activeLeague } = useActiveLeague();
    const { data: campaign, isLoading, error: loadError } = useQuery({
        queryKey: ['campaign-edit', campaignId],
        queryFn: () => axios.get(`/api/campaigns/${campaignId}/`, { withCredentials: true }).then((r) => r.data),
    });

    if (isLoading) {
        return (
            <div className="card">
                <div className="card-body text-center py-5">
                    <div className="spinner-border" role="status" />
                </div>
            </div>
        );
    }
    if (loadError) {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="alert alert-danger" role="alert">Failed to load campaign.</div>
                </div>
            </div>
        );
    }

    return (
        <CampaignWizard
            mode="edit"
            campaignId={campaignId}
            campaign={campaign}
            leagueId={campaign?.league_id || activeLeague?.id}
            leagueName={campaign?.league_name || activeLeague?.name}
        />
    );
}
